const topbar = {
    docs: '文档',
    help: '帮助',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
